// ─────────────────────────────────────────────────────────────────────────
// «이 문서는 콘솔인가» — 경로로 정한다. 정하는 곳은 여기 **한 곳**이다.
//
// 쓰는 곳 둘:
//   · src/index.js screenFor()      — 콘솔 라우터를 받을지, 학생 첫 화면(App)을 그릴지
//   · src/admin/firebase/config.js  — Firebase 앱을 어느 이름으로 띄울지(= Auth 세션을 나눌지)
//
// 왜 Auth 세션을 나누나(2026-09-20 실측): 담당자 브라우저에서 학생 화면(코드 입장)과 기관 콘솔이
// **같은 Firebase Auth 세션**을 썼다. 학생 코드 입장은 익명 로그인이라, 그 순간 콘솔의 로그인이
// 밀려나고 콘솔 탭은 「계정은 인증됐지만 연결된 기관이 없습니다」로 떨어졌다 — 익명 계정에는
// 기관이 없으니 서버가 «없다»고 확인해 준 것이라 재시도로도 안 돌아온다. 담당자에게는
// "기관 정보가 자꾸 리셋된다"로 보였다. 콘솔 문서에 이름 붙은 앱을 쓰면 세션 저장 키가 갈려
// 둘이 같은 브라우저에 공존한다.
// ─────────────────────────────────────────────────────────────────────────

/** react-router 와 같은 판정 — 대소문자를 가리지 않고, 끝의 / 는 무시한다. */
export function normalizePath(rawPath) {
  return (String(rawPath || '/')).toLowerCase().replace(/\/+$/, '') || '/';
}

/** /admin, /operator 와 그 아래 전부. 그 밖(학생·서고·시뮬)은 아니다. */
export function isConsolePath(rawPath) {
  return /^\/(admin|operator)(\/|$)/.test(normalizePath(rawPath));
}
